import { post, get, put, deleteApi } from '../axiosFun';
/* 科目类别字典 */
// 分页
const courseCategoryPage = data => {
  return post('/train/course-category/page', data)
};
// 列表
const courseCategoryList = data => {
  return post('/train/course-category/list', data)
};
// 详情
const courseCategoryDetail = courseCategoryId => {
  return get('/train/course-category/detail/' + courseCategoryId)
};
// 新增
const courseCategoryAdd = data => {
  return post('/train/course-category/add', data)
};
// 编辑
const courseCategoryEdit = data => {
  return put('/train/course-category/edit', data)
};
// 删除
const courseCategoryRemove = data => {
  return deleteApi('/train/course-category/remove', data)
};
export default {
  courseCategoryPage,
  courseCategoryList,
  courseCategoryDetail,
  courseCategoryAdd,
  courseCategoryEdit,
  courseCategoryRemove
}




// WEBPACK FOOTER //
// ./src/api/onlineTraining/classification.js